import { AbstractControl } from '@angular/forms';
import { BASE_PHONE_NUMBER_REGEXP } from '../constants/base-regexp-patterns.const';

export const basePhoneNumberValidator = () => {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const phoneNumberPattern = new RegExp(BASE_PHONE_NUMBER_REGEXP);
    if (control.value && !phoneNumberPattern.test(control.value)) {
      return { phoneNumberInvalid: true };
    }
    return null;
  };
};
